/* eslint-disable @typescript-eslint/no-explicit-any */

import { Form, Radio } from 'antd'
import classnames from 'classnames'
import React, { type ReactNode } from 'react'
import type { BaseInputProps } from '../../../types/types'
import './InputRadioGroup.less'
import styled from 'styled-components'

export type option = {
  value: string
  label: string
  renderLabel?: () => ReactNode
}

export type InputRadioGroupProps = {
  onChange: (e: any) => void
  value: string
  options: option[]
  label?: string
  fullWidth?: boolean
  layout?: 'column' | 'row'
  required?: boolean
  oneLine?: boolean
  localization?: { errorMessage: string }
  noBorder?: boolean
  displayRow?: boolean
  isMobileLayout?: boolean
} & BaseInputProps

const Wrapper = styled.div`
  .ant-radio-wrapper-checked {
    border: 1px solid ${({ theme }) => theme.color.status.primary} !important;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: ${({ theme }) => theme.color.status.primary} !important ;
  }

  .ant-radio-wrapper:hover {
    border: 1px solid ${({ theme }) => theme.color.status.primary};
    color: #000000;
  }
`

function RadioGroup({
  value,
  onChange,
  options,
  layout = 'column',
  label,
  fullWidth,
  required,
  oneLine,
  localization,
  noBorder = false,
  displayRow = false,
  isMobileLayout = false,
  className: classNameProp
}: InputRadioGroupProps) {
  const className = (option: option) =>
    classnames({
      radio_not_selected: value !== undefined && option.value !== value,
      ant_full_width: fullWidth,
      ant_not_full_width: !fullWidth,
      no_border: noBorder
    })

  const classNameWrapper = () =>
    classnames({
      one_line: oneLine,
      no_border: noBorder,
      ant_display_row: displayRow,
      ant_mobile_row_80vw: isMobileLayout
    })

  return (
    <Wrapper
      id="radiogroup"
      className={`${classNameProp} ${classNameWrapper()}`}
    >
      <Form.Item
        label={label}
        // @ts-ignore
        name={required && 'radio'}
        labelCol={layout === 'column' ? { span: 24 } : {}}
        wrapperCol={layout === 'column' ? { span: 24 } : {}}
        style={{ marginBottom: displayRow ? 0 : 'inherit' }}
        rules={[
          {
            required,
            message: localization?.errorMessage || 'Please select an option!'
          }
        ]}
      >
        <Radio.Group value={value}>
          {options?.map((option) => (
            <Radio
              key={option.value}
              className={className(option)}
              value={option.value}
              onClick={() => onChange(option.value)}
            >
              {option.renderLabel ? option.renderLabel() : option.label}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </Wrapper>
  )
}

export default RadioGroup
